import { render, staticRenderFns } from "./Userform.vue?vue&type=template&id=e72229c0&scoped=true"
import script from "./Userform.vue?vue&type=script&lang=js"
export * from "./Userform.vue?vue&type=script&lang=js"
import style0 from "./Userform.vue?vue&type=style&index=0&id=e72229c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72229c0",
  null
  
)

export default component.exports